import { ApolloError } from '@apollo/client';

import {
  useErpFundingOperatorQuery,
  useErpFundingUpcomingIntakesQuery,
} from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { useDofinPermissions } from './useDofinPermissions';

/**
 * ТЗ 0024 — карточка оператора.
 *
 * Корневое поле `fundingOperator(id)` существовало и не вызывалось ниоткуда,
 * а список тянул по сети одиннадцать полей, которые маппер хука выбрасывал:
 * критерии участника, ссылки на проект и документы, состояние робота и
 * историю окон набора. Здесь они наконец доходят до экрана.
 */
export const useFundingOperator = (id?: string | null) => {
  const { data, loading, error, refetch } = useErpFundingOperatorQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    operator: data?.fundingOperator ?? null,
    loading,
    error: error as ApolloError | undefined,
    refetch: useStableRefetch(refetch),
  };
};

/**
 * «Чей набор открывается на днях» — по всем операторам сразу.
 *
 * Запрос пропускается для ролей без доступа: `PermissionDenied` летит в
 * `errors`, то есть отклоняет промис, а не возвращает `customErrors`.
 */
export const useUpcomingIntakes = (withinDays = 30) => {
  const { canRead } = useDofinPermissions();
  const { data, loading, error, refetch } = useErpFundingUpcomingIntakesQuery({
    variables: { withinDays },
    skip: !canRead,
    fetchPolicy: 'cache-and-network',
  });

  return {
    intakes: data?.fundingUpcomingIntakes ?? [],
    loading,
    // Отказ сервера НЕЛЬЗЯ отдавать пустым списком: экран напишет «наборов
    // в ближайшие дни нет», и менеджер спокойно закроет вкладку.
    error: error as ApolloError | undefined,
    refetch: useStableRefetch(refetch),
  };
};
